import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { MoneyForwardElement } from '@/features/w/[identifier]/setting/connect/{components}/MoneyForwardElement';
import { BoardElement } from '@/features/w/[identifier]/setting/connect/{components}/BoardElement';

export const WorkspaceConnect = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('外部サービス連携'), []);
  useEffect(() => setBreadcrumbs([]), []);

  const { setShowLoading } = useLoading();
  const { _w_, me } = useCurrentWorkspace();

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'connect'} />

        <div className="row">
          <div className="col-12 col-lg-7 mx-auto">
            <MoneyForwardElement />
            <BoardElement />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
